const clockData = [
    {
        slide: 0,
        slideText: "The key events of November 22nd 1935.",
        minuteRotation: 0,
        hourRotation: 0,
        timeText: "12:00am"
    },
    {
        slide: 1,
        slideText: "The Paradox Diamond is delivered to the museum and Mary Floyd escorts it to the Diamond Room.",
        minuteRotation: 3240,
        hourRotation: 270,
        timeText: "09:00am"
    },
    {
        slide: 2,
        slideText: "Harriette Watts is overheard having a hushed telephone conversation in the Staff Office. The reason is unknown.",
        minuteRotation: 3690,
        hourRotation: 300,
        timeText: "10:15am"
    },
    {
        slide: 3,
        slideText: "Logan Eckart interviews Nigel Haysmith, and takes a photo of the Paradox Diamond, for the New York Post.",
        minuteRotation: 4170,
        hourRotation: 330,
        timeText: "11:35am"
    },
    {
        slide: 4,
        slideText: "Bruce Esherwood and Tara Smythe are witnessed having a heated discussion about museum funding in the Main Exhibition Hall.",
        minuteRotation: 4980,
        hourRotation: 390,
        timeText: "01:50pm"
    },
    {
        slide: 5,
        slideText: "Dorris Humphries is the last person to see the Paradox Diamond in it's display case in the Diamond Room.",
        minuteRotation: 5550,
        hourRotation: 450,
        timeText: "03:25pm"
    },
    {
        slide: 6,
        slideText: "The Paradox Diamond is discovered to have gone missing!",
        minuteRotation: 5790,
        hourRotation: 480,
        timeText: "04:05pm"
    }
]

export default clockData